import { atom } from "recoil";
import AsyncLocalStorage from "../utils/AsyncLocalStorage";

export const CONTENT_TOGGLE = "toggle";
export const CONTENT_INPUT = "input";
export const CONTENT_RADIO = "radio";

export type SettingType = Record<string, SettingCategoryType>;

export type SettingCategoryType = Record<string, SettingContentType>;

export type SettingContentType = {
  config_type: string;
  env_type: string;
  name: string;
  value: string;
  content_list: string[];
};

export const settingsState = atom<SettingType>({
  key: "settings",
  default: {
    payment: {
      bizno: {
        config_type: "input",
        env_type: "payment",
        name: "bizno",
        value: "123456789",
        content_list: [],
      },
      tid: {
        config_type: "input",
        env_type: "payment",
        name: "tid",
        value: "123456789",
        content_list: [],
      },
      van: {
        config_type: "radio",
        env_type: "payment",
        name: "van",
        value: "NICE",
        content_list: ["NICE", "KOVAN"],
      },
    },
    view: {
      kioskmode: {
        config_type: "toggle",
        env_type: "payment",
        name: "kioskmode",
        value: "0",
        content_list: [],
      },
      screen: {
        config_type: "radio",
        env_type: "view",
        name: "screen",
        value: "default",
        content_list: ["default", "portrait", "reversePortrait"],
      },
    },
  },
  effects: [
    ({ setSelf, onSet }) => {
      const savedAuthData = AsyncLocalStorage.getItem("settings");

      if (savedAuthData) {
        try {
          setSelf(JSON.parse(savedAuthData) as SettingType);
        } catch (error) {
          console.error("Failed to parse settings:", error);
        }
      }

      onSet((newValue, _, isReset) => {
        isReset
          ? AsyncLocalStorage.removeItem("settings")
          : AsyncLocalStorage.setItem("settings", JSON.stringify(newValue));
      });
    },
  ],
});
